import { searchPromotedEvents } from '@eventbrite/ads';
import { hasIncreasedAds } from './experiments';

type SeachPromotedEventsForYouPayload = {
    location: LocationInfo;
    subInterface: string;
};

export async function searchPromotedEventsForYou(
    payload: SeachPromotedEventsForYouPayload,
) {
    const adSlots = hasIncreasedAds() ? 2 : 1;

    return searchPromotedEvents({
        slots: adSlots,
        page: 1,
        interface: 'homepage',
        sub_interface: payload.subInterface,
        search: {
            dates: ['current_future'], //TODO CHANGE THIS
            place: transformLocationToAdsPayload(payload.location),
        },
    });
}

type LocationInfo = {
    placeId?: string | null;
    latitude?: number;
    longitude?: number;
    isOnline?: boolean;
};

export function transformLocationToAdsPayload({
    placeId,
    latitude,
    longitude,
    isOnline,
}: LocationInfo) {
    if (isOnline) {
        return {
            is_online: true,
        };
    }

    if (!isOnline && latitude && longitude) {
        return {
            geo_point: {
                lat: latitude,
                lon: longitude,
                radius: 50,
            },
            is_online: false,
        };
    }

    return {
        is_online: false,
        place_id: placeId ?? undefined,
    };
}
